import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { getBrandCustom } from "../../../../../../../util/getCustomColor";

interface BadgeStatusProps {
  isActive: boolean;
}

export const BadgeStatus = styled("div", {
  shouldForwardProp: (prop) => prop !== "isActive",
})<BadgeStatusProps>(({ isActive }) => ({
  backgroundColor: isActive ? "#DCFBEA" : "#FEF3F2",
  color: isActive ? "#249F5D" : "#D92D20",
  borderRadius: "20px",
  padding: "6px 10px",
  fontFamily: "Inter",
  fontWeight: 600,
  fontSize: "10px",
  lineHeight: "20px",
  display: "inline-block",
}));

const styles = makeStyles(() => ({
  statusBadge: {
    background: "#FEE4E2 !important",
    border: "1px solid #E0E2E7",
    padding: "3px 10px",
    borderRadius: 20,
    height: 32,
    fontWeight: 600,
    fontSize: 10,
    lineHeight: "20px",
    color: "#F97066 !important",
  },
  statusBadgeActive: {
    background: "#D1FADF !important",
    border: "1px solid #D1FADF",
    color: "#32D583 !important",
  },
  button: {
    cursor: "pointer",
  },
  headerBreadcrumbs: {
    "& ol": {
      alignItems: "flex-end",
    },
  },
  headerBreadcrumbsTitle: {
    fontSize: 18,
    lineHeight: "24px",
    fontWeight: "bold",
    color: getBrandCustom("primaryColor", "#38cfc4"),
    fontFamily: `'Manrope', sans-serif`,
    "&.active": {
      color: "#465869",
    },
  },
  changeAllStatusButton: {
    whiteSpace: "nowrap",
    "& span > div": {
      display: "flex",
      alignItems: "center",
    },
  },
}));

export default styles;
